module.exports = __webpack_public_path__ + "img/map_3.679b129b.png";